// extracted by mini-css-extract-plugin
export default {"root":"GoogleLogin_root__vdp6j","button":"GoogleLogin_button__CM3d4"};